import React from 'react'
import { useLocation } from 'react-router-dom'

declare global { interface Window { gtag?: (...args: any[]) => void } }

export function AnalyticsTracker() {
  const location = useLocation()

  React.useEffect(() => {
    // Only in production and with consent
    if (!import.meta.env.PROD) return
    try {
      const consent = localStorage.getItem('analytics_consent')
      if (consent !== 'accepted') return
    } catch {}
    if (typeof window.gtag !== 'function') return
    window.gtag('event', 'page_view', {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
      page_title: document.title,
    })
  }, [location])

  return null
}

